import './styles/App.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, MotionConfig } from "framer-motion";
import {
    HomePageRoute,
    LoginsRoute,
    CVRoutes,
    LogoutsRoute,
    ManageUsersRoute,
    ProjectDetailRoutes,
    ProjectRoutes,
    BlogRoutes, BlogDetailRoutes, ManageProjectRoutes, ManageBlogsRoute, ManageTechnologyRoutes
} from "./routes";

import PrivateRoute from './components/PrivateRoute';
import { UserProvider } from "./Contexts/AuthenticatedUserContext";
import { ScrollToTop } from "./components/ScrollToTop";
import { PageTransition } from "./components/PageTransition";

const AnimatedRoutes: React.FC = () => {
    const location = useLocation();
    return (
        <AnimatePresence mode="wait">
            <PageTransition key={location.pathname}>
                <Routes location={location}>
                    <Route path={LoginsRoute.url} Component={LoginsRoute.component}/>
                    <Route path={HomePageRoute.url} Component={HomePageRoute.component}/>
                    <Route path={CVRoutes.url} Component={CVRoutes.component}/>
                    <Route path={ProjectRoutes.url} Component={ProjectRoutes.component}/>
                    <Route path={ProjectDetailRoutes.url} Component={ProjectRoutes.component}/>
                    <Route path={BlogRoutes.url} Component={BlogRoutes.component}/>
                    <Route path={BlogDetailRoutes.url} Component={BlogDetailRoutes.component}/>
                    <Route path={LogoutsRoute.url} Component={LogoutsRoute.component}/>

                    <Route element={<PrivateRoute requiredRole="ADMIN"/>}>
                        <Route path={ManageUsersRoute.url} Component={ManageUsersRoute.component}/>
                        <Route path={ManageProjectRoutes.url} Component={ManageProjectRoutes.component}/>
                        <Route path={ManageTechnologyRoutes.url} Component={ManageTechnologyRoutes.component}/>
                        <Route path={ManageBlogsRoute.url} Component={ManageBlogsRoute.component}/>
                    </Route>
                </Routes>
            </PageTransition>
        </AnimatePresence>
    );
};

const App: React.FC = () => {
    return (
        <UserProvider>
            <MotionConfig reducedMotion="user">
                <Suspense fallback={<div>Loading...</div>}>
                    <BrowserRouter>
                        <ScrollToTop />
                        <AnimatedRoutes />
                    </BrowserRouter>
                </Suspense>
            </MotionConfig>
        </UserProvider>
    );
};

export default App;
